export default "/acfdf2704e412c85fb550b6408622629b62bf7b2/ee9346a7a9322dc42520ebdf49402b79.svg";